import { getNodeFullText } from 'ricos-content/libs/nodeUtils';
import { Node_Type } from 'ricos-schema';
import { isAnchorableTextNode, isThumbnailNode, textNodesMapper, atomicNodesMapper, isAnchorableAtomicPluginNode, Anchorable_Blocks_Types, headersMapper } from './helpers.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const mapTextNodeType = (node) => {
  var _a;
  const { type } = node;
  if (node.headingData) {
    const headingLevel = (_a = node.headingData) == null ? void 0 : _a.level;
    return headersMapper[headingLevel];
  } else {
    return textNodesMapper[type];
  }
};
const getAnchorType = (node) => {
  const { type } = node;
  return __spreadValues(__spreadValues({}, atomicNodesMapper), textNodesMapper)[type];
};
const mapTypesAndIndices = (block, typesWithIndices) => {
  if (!typesWithIndices[block.anchorType]) {
    typesWithIndices[block.anchorType] = 1;
  } else {
    typesWithIndices[block.anchorType]++;
  }
  block.index = typesWithIndices[block.anchorType];
};
const getType = (node) => {
  if (isAnchorableAtomicPluginNode(node)) {
    return Anchorable_Blocks_Types.ATOMIC;
  } else {
    return mapTextNodeType(node);
  }
};
const getData = (node) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p;
  if (node.type === Node_Type.IMAGE) {
    const file_name = (_c = (_b = (_a = node.imageData) == null ? void 0 : _a.image) == null ? void 0 : _b.src) == null ? void 0 : _c.id;
    if (file_name) {
      return {
        src: {
          file_name
        }
      };
    }
  }
  if (node.type === Node_Type.GALLERY) {
    const url = (_h = (_g = (_f = (_e = (_d = node.galleryData) == null ? void 0 : _d.items[0]) == null ? void 0 : _e.image) == null ? void 0 : _f.media) == null ? void 0 : _g.src) == null ? void 0 : _h.url;
    if (url) {
      return {
        items: [{ url }]
      };
    }
  }
  if (node.type === Node_Type.GIF) {
    const downsizedUrl = (_j = (_i = node.gifData) == null ? void 0 : _i.downsized) == null ? void 0 : _j.gif;
    if (downsizedUrl) {
      return {
        gif: { downsizedUrl }
      };
    }
  }
  if (node.type === Node_Type.VIDEO) {
    const thumbnail = (_m = (_l = (_k = node.videoData) == null ? void 0 : _k.thumbnail) == null ? void 0 : _l.src) == null ? void 0 : _m.id;
    const src = (_p = (_o = (_n = node.videoData) == null ? void 0 : _n.video) == null ? void 0 : _o.src) == null ? void 0 : _p.url;
    if (thumbnail) {
      return {
        src: { thumbnail: { pathname: thumbnail } }
      };
    } else if (src) {
      return {
        src
      };
    }
  }
};
const getAnchorableBlocksFromAnchorableNodes = (anchorableNodes) => {
  const anchorableBlocks = anchorableNodes.map((node) => {
    const key = node.id;
    const type = getType(node);
    const anchorType = getAnchorType(node);
    let text;
    if (isAnchorableTextNode(node)) {
      text = getNodeFullText(node);
    }
    let data;
    if (isThumbnailNode(node)) {
      data = getData(node);
    }
    const newNode = __spreadValues(__spreadValues({
      key,
      type,
      anchorType
    }, text && { text }), data && { data });
    return newNode;
  });
  const typesWithIndices = {};
  anchorableBlocks.forEach((block) => mapTypesAndIndices(block, typesWithIndices));
  return {
    anchorableBlocks,
    pluginsIncluded: Object.keys(typesWithIndices)
  };
};

export { getAnchorableBlocksFromAnchorableNodes };
//# sourceMappingURL=anchorAdapter.js.map
